import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { CustomerService } from '../service/CustomerService';
import { Button } from 'primereact/button';
import { useHistory } from "react-router-dom";
import React from 'react';

export const UsersConfirmationPage = () => {
    
    const [usersConfirmation, setUsersConfirmation] = React.useState(null);
    const [globalFilter, setGlobalFilter] = React.useState('');
    const [keyword, setKeyword] = React.useState('');
    const [page, setPage] = React.useState(1);
    const [size, setSize] = React.useState(100);
    const [loading, setLoading] = React.useState(true);

    let history = useHistory();

    React.useEffect(() => {
        const requestPayload = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*' ,
                'Authorization': 'Bearer ' +localStorage.getItem('jwt')
            },
            body: JSON.stringify({
                keyword: keyword,
                page: page,
                size: size
            })
        }

        fetch('https://springboot-widy-app.widyan123.site/widy-app/user-confirmation/paging', requestPayload)
        .then(res => {
            if(res.status === 401) {
                return Promise.reject(res);
            } else {
                return Promise.resolve(res);
            } 
        })
        .then(res => res.json())
        .then(res => {
            setUsersConfirmation(res.data);
            setLoading(false);
        })
        .catch(res => {            
            history.push('/login');         
        }); 
    }, []);

    const openEdit = (rowData) => {
        history.push({
            pathname: '/user-confirmation',
            state: {
                todo: 'Ubah',
                dataUserConfirmation: rowData
            }
        });
    }

    const roleTableHeader = (
        <div className="table-header">
            Users Confirmation
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
            </span>
        </div>
    );

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const usernameBodyTemplate = (rowData) => {
        return (
            <>
            <span className='p-column-title'>Username</span>
            {rowData.user.username}
            </>
        ) 
    };

    const createdAtBodyTemplate = (rowData) => {
        const date = new Date(rowData.createdAt);
        const createdAt = dateFormat(date);
        return (
            <>
            <span className='p-column-title'>Created At</span>
            {createdAt}
            </>
        )
    }

    const updatedAtBodyTemplate = (rowData) => {
        const date = rowData.updatedAt === null ? null : new Date(rowData.updatedAt);
        const updatedAt = date === null ? '-' : dateFormat(date);
        return (
            <>
            <span className='p-column-title'>Updated At</span>
            {updatedAt}
            </>
        )
    }

    const expiredBodyTemplate = (rowData) => {
        const date = new Date(rowData.expired);
        const expired = dateFormat(date);
        return (
            <>
            <span className='p-column-title'>Expired</span>
            {expired}
            </>
        )
    }

    const statusBodyTemplate = (rowData) => {
        return (
            <>
            <span className='p-column-title'>Status</span>
            {rowData.status === 1 ? 'Telah Konfirmasi':'Belum Konfirmasi'}
            </>
        )
    }

    function dateFormat(date) {
        return  [
                    date.getDate() < 10 ? '0'+date.getDate():date.getDate(), 
                    date.getMonth()+1 < 10 ? '0'+Math.round(date.getMonth()+1):date.getMonth()+1, 
                    date.getFullYear()
                ]
                .join('/')+' '+
                [
                    date.getHours() < 10 ? '0'+date.getHours():date.getHours(), 
                    date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()
                ]
                .join(':');

    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => openEdit(rowData)} />
            </div>
        );
    }

    return (
        <div className="grid table-demo">
            <div className="col-12">
                <div className="card">
                    <DataTable value={usersConfirmation} paginator className="p-datatable-customers" rows={7} dataKey="id" rowHover
                        globalFilter={globalFilter} emptyMessage="No customers found." loading={loading} header={roleTableHeader}>
                        <Column field="username" header="Username" sortable body={usernameBodyTemplate}></Column>
                        <Column field="email" header="Email" sortable body={bodyTemplate}></Column>
                        <Column field="createdAt" header="Created At" sortable body={createdAtBodyTemplate}></Column>
                        <Column field="updatedAt" header="Updated At" sortable body={updatedAtBodyTemplate}></Column>
                        <Column field="expired" header="Expired" sortable body={expiredBodyTemplate}></Column>
                        <Column field="status" header="Status" sortable body={statusBodyTemplate}></Column>
                        <Column header="Action" body={actionBodyTemplate}></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    )
}
